import { Routes, Route } from "react-router-dom";
import { Documents } from "./Documents";
import { DocumentsSet } from "./DocumentsSet";
import { OtherDocuments } from "./OtherDocuments";

export type DocumentsRouteProps = {
  hideRootBack?: boolean;
};

export const DocumentsRoute: React.FC<DocumentsRouteProps> = ({
  hideRootBack,
}) => {
  return (
    <Routes>
      <Route path="/" element={<Documents hideBack={hideRootBack} />} />
      <Route path="/set/:documentsUUID" element={<DocumentsSet />} />
      <Route path="/other" element={<OtherDocuments />} />
    </Routes>
  );
};
